module.exports = __webpack_public_path__ + "img/machine_oil_icon.ffdfb4a6.png";